const DiscountBadge = ({ discount, redBadge }) => {
  return (
    <span
      className={`discount-badge ${redBadge ? 'badge-red' : 'badge-gold'}`}
      title={`Obtén ${discount}% de descuento`}
    >
      {` ${discount}%`}
    </span>
  );
};

export default DiscountBadge;
